<template>
  <div>
    <!--CADASTRAR NOVO EMAIL-->
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay esocial-modal-overlay--nested" v-if="showFormRegister" @click.self="closeRegister">
        <div class="esocial-modal">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Enviar Novo Email Lote {{ parent.formData.lote }}</span>
            <button class="esocial-modal__close" @click="closeRegister">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body" v-loading="config.loading.content">
            <div class="esocial-modal__form-no-info">
              <ed-form :data="formData" :config="config" :response="response" :itens="formItems">
                <div slot="form-footer"></div>
              </ed-form>
            </div>
            <div class="esocial-modal__hint">{{ formItems[0] && formItems[0].info }}</div>

            <div class="esocial-modal__preview" v-if="emailsValidos.length">
              <span class="esocial-modal__preview-label">{{ emailsValidos.length }} destinatário(s) válido(s)</span>
              <div class="esocial-modal__preview-chips">
                <span class="esocial-modal__chip" v-for="(email, i) in emailsValidos" :key="i">{{ email }}</span>
              </div>
            </div>
          </div>

          <div class="esocial-modal__footer">
            <button class="esocial-modal__btn esocial-modal__btn--secondary" @click="abrirPreviewEmail">
              <i class="fa fa-eye"></i> Ver preview do email
            </button>
            <button class="esocial-modal__btn esocial-modal__btn--primary" :disabled="config.loading.save" @click="salvar">
              <i class="fa fa-spinner fa-spin" v-if="config.loading.save"></i>
              Enviar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!--PREVIEW DO EMAIL-->
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay esocial-modal-overlay--nested" v-if="showPreview" @click.self="closePreview">
        <div class="esocial-modal esocial-modal--wide">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Preview do Email Lote {{ parent.formData.lote }}</span>
            <button class="esocial-modal__close" @click="closePreview">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body esocial-modal__body--preview" v-loading="loadingPreview">
            <iframe v-if="previewHtml" class="esocial-modal__preview-frame" :srcdoc="previewHtml"></iframe>
          </div>
        </div>
      </div>
    </transition>

    <!--LISTAR EMAILS-->
    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="showFormList" @click.self="closeList">
        <div class="esocial-modal esocial-modal--wide">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Emails Lote {{ parent.formData.lote }}</span>
            <button class="esocial-modal__close" @click="closeList">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <div class="esocial-modal__actions">
              <button class="esocial-modal__btn esocial-modal__btn--primary" @click="onRegister">
                <i class="fa fa-plus"></i> Novo Email
              </button>
            </div>

            <esocial-tabela
              :tableHead="tableHead"
              :tableData="tableData"
              :loadingTable="loadingTable"
              :pagination="pagination"
              :response="response"
              :search="search"
              :onSearch="getLog"
              disableCheckAll
              emptyText="Nenhum email enviado para este lote ainda."
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import EdForm from "common/form";
import Rest from "common/rest";
import EsocialTabela from "../../includes/tabela";
import FormItems from "../_form/lote-email-cadastro";

export default {
  name: "esocial-lotes-email",
  mixins: [Rest],
  components: { EdForm, EsocialTabela },
  props: {
    parent: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showForm: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },

  watch: {
    showForm() {
      this.showFormList = !this.showFormList;

      if (this.showFormList) {
        this.getLog();
      }
    },
  },

  computed: {
    emailsValidos() {
      var regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return (this.formData.destinatario || "")
        .split(";")
        .map((email) => email.trim())
        .filter((email) => email.length && regexEmail.test(email));
    },
  },

  data() {
    return {
      config: {
        click: {},
        loading: {
          save: false,
          content: false,
        },
        list: {},
      },
      response: {},
      pagination: {},
      search: null,
      tableHead: [
        {
          key: "destinatario",
          sortable: true,
          label: "Destinatário",
        },
        {
          key: "tipo_status",
          label: "Status",
          show_status_timeline: true,
        },
        {
          key: "updated_at",
          sortable: true,
          show_user: true,
          label: "Atualização",
        },
      ],
      formData: {
        destinatario: null,
      },
      tableData: [],
      formItems: [],
      loadingTable: false,
      showFormList: false,
      showFormRegister: false,
      showPreview: false,
      loadingPreview: false,
      previewHtml: null,
    };
  },

  mounted() {
    this.formItems = FormItems;
  },

  methods: {
    closeList() {
      this.showFormList = false;
    },

    closeRegister() {
      this.showFormRegister = false;
    },

    onRegister() {
      this.showFormRegister = true;
    },

    abrirPreviewEmail() {
      this.showPreview = true;
      this.loadingPreview = true;
      this.previewHtml = null;

      this.get("esocial/lotes/" + this.parent.formData.id + "/email/preview").then((result) => {
        this.previewHtml = result[0];
        this.loadingPreview = false;
      });
    },

    closePreview() {
      this.showPreview = false;
    },

    getLog(_search, _page, _pagination) {
      this.loadingTable = true;
      this.response = {};

      this.get("log/email/esocial-lote/" + this.parent.formData.id, {
        search: _search,
        page: _page,
        pagination: _pagination,
      }).then((result) => {
        result = result[0];
        this.response = result;

        var data = [],
          tableData = [],
          pagination = {};

        if (result.status == 200) {
          data = result.data.data;
          pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            tableData.push({
              destinatario: data[i].destinatario ? data[i].destinatario.split(";").join("<br>") : "---",
              updated_at: this.toDate(data[i].created_at),
              _data: data[i],
              buttons: [],
            });
          }
        }

        this.pagination = pagination;
        this.tableData = tableData;
        this.loadingTable = false;
      });
    },

    validarEmails() {
      var destinatario = (this.formData.destinatario || "").trim();

      if (!destinatario) {
        return { destinatario: ["Campo Obrigatório"] };
      }

      var regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      var emails = destinatario.split(";").map((email) => email.trim()).filter((email) => email.length);
      var invalidos = emails.filter((email) => !regexEmail.test(email));

      if (invalidos.length) {
        return { destinatario: ["Email inválido: " + invalidos.join(", ")] };
      }

      if (!this.emailsValidos.length) {
        return { destinatario: ["Informe ao menos um email válido"] };
      }

      return null;
    },

    salvar() {
      var erros = this.validarEmails();

      if (erros) {
        this.response = { status: 400, options: { data: erros } };
        return;
      }

      this.config.loading.save = true;
      this.response = {};

      this.post("esocial/lotes/" + this.parent.formData.id + "/email", this.formData).then((result) => {
        this.config.loading.save = false;

        result = result[0];
        this.response = result;

        if (result.status == 200) {
          this.edMsg("Email cadastrado com sucesso");
          this.closeRegister();
          this.getLog();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;

  &--nested {
    z-index: 1600;
  }
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;

  &--wide {
    width: 90%;
    max-width: 980px;
  }
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;

  &--preview {
    padding: 0;
    display: flex;
    min-height: 60vh;
  }
}

.esocial-modal__form-no-info {
  ::v-deep .fa-question-circle {
    display: none;
  }
}

.esocial-modal__hint {
  margin-top: -12px;
  font-size: 11px;
  color: #9aa0a8;
  line-height: 1.4;
}

.esocial-modal__preview {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal__preview-label {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.esocial-modal__preview-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.esocial-modal__chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(26, 138, 62, 0.1);
  color: #1a8a3e;
  font-size: 11px;
  font-weight: 600;
}

.esocial-modal__preview-frame {
  width: 100%;
  min-height: 60vh;
  border: none;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal__actions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 14px;
}

.esocial-modal__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 34px;
  padding: 0 16px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;

  &--primary {
    background: #09f;
    color: #fff;

    &:hover {
      background: #0087dd;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  &--secondary {
    background: #f1f2f4;
    color: #1f2329;
    margin-right: auto;

    &:hover {
      background: #e4e7ed;
    }
  }
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?de37eb24